import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessIxDiamantBuExportStatus: 'idle',
    startProcessIxDiamantBuExportError: undefined as any,
    loadUserParamsProcessIxDiamantBuExportStatus: 'idle',
    loadUserParamsProcessIxDiamantBuExportError: undefined as any,

    processIxDiamantBuExportList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessIxDiamantBuExport = createAsyncThunk('processIxDiamantBuExportSlice/startProcessIxDiamantBuExport', async ({ processIxDiamantBuExport }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessIxDiamantBuExport/`,
        prepareData(processIxDiamantBuExport),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessIxDiamantBuExportStatus } = getState().processIxDiamantBuExportSlice
        return startProcessIxDiamantBuExportStatus !== 'pending'
    }
})

export const loadUserParamsProcessIxDiamantBuExport = createAsyncThunk('processIxDiamantBuExportSlice/loadUserParamsProcessIxDiamantBuExport', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessIxDiamantBuExport/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessIxDiamantBuExportStatus } = getState().processIxDiamantBuExportSlice
        return loadUserParamsProcessIxDiamantBuExportStatus !== 'pending'
    }
})

const ProcessIxDiamantBuExportSlice = createSlice({
    name: 'processIxDiamantBuExportSlice',
    initialState,
    reducers: {
        resetstartProcessIxDiamantBuExport: (state) => {
            state.job = undefined
            state.startProcessIxDiamantBuExportError = undefined
        },
        resetstartProcessIxDiamantBuExportError: (state) => {
            state.startProcessIxDiamantBuExportError = undefined
        },
        resetloadUserParamsProcessIxDiamantBuExport: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessIxDiamantBuExportError = undefined
        },
        resetloadUserParamsProcessIxDiamantBuExportError: (state) => {
            state.loadUserParamsProcessIxDiamantBuExportError = undefined
        },
        removeFromProcessIxDiamantBuExportListById: (state, action) => {
            state.processIxDiamantBuExportList = state.processIxDiamantBuExportList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessIxDiamantBuExportListByIds: (state, action) => {
            state.processIxDiamantBuExportList = state.processIxDiamantBuExportList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processIxDiamantBuExportList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessIxDiamantBuExportStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processIxDiamantBuExportList = []
            state.startProcessIxDiamantBuExportStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessIxDiamantBuExport.pending, (state) => {
            state.startProcessIxDiamantBuExportStatus = 'pending'
            state.startProcessIxDiamantBuExportError = undefined
        })
        builder.addCase(startProcessIxDiamantBuExport.fulfilled, (state, action) => {
            state.startProcessIxDiamantBuExportStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessIxDiamantBuExport.rejected, (state, action) => {
            state.startProcessIxDiamantBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessIxDiamantBuExportError = action.error.message
            } else {
                state.startProcessIxDiamantBuExportError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessIxDiamantBuExport.pending, (state) => {
            state.loadUserParamsProcessIxDiamantBuExportStatus = 'pending'
            state.loadUserParamsProcessIxDiamantBuExportError = undefined
        })
        builder.addCase(loadUserParamsProcessIxDiamantBuExport.fulfilled, (state, action) => {
            state.loadUserParamsProcessIxDiamantBuExportStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessIxDiamantBuExport.rejected, (state, action) => {
            state.loadUserParamsProcessIxDiamantBuExportStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessIxDiamantBuExportError = action.error.message
            } else {
                state.loadUserParamsProcessIxDiamantBuExportError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessIxDiamantBuExport,
    resetstartProcessIxDiamantBuExportError,
    resetloadUserParamsProcessIxDiamantBuExport,
    resetloadUserParamsProcessIxDiamantBuExportError,
    removeFromProcessIxDiamantBuExportListById,
    removeFromProcessIxDiamantBuExportListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessIxDiamantBuExportSlice.actions
export default ProcessIxDiamantBuExportSlice.reducer
